<div class="mt-2">
  <div class="row">
    <div class="col-sm font-weight-bold d-flex align-items-center">
      {{ 'public.profile.address.title' | translate }}
    </div>
    <div class="col-sm text-right">
      <app-button startIcon="fa-plus" (click)="onAddAddress()">
        {{ 'public.profile.address.add' | translate }}
      </app-button>
    </div>
  </div>
  <div class="separator my-3"></div>

  <div *ngFor="let address of customerProfile?.addresses || []">
    <div class="row">
      <div class="font-size-primary col-sm d-flex align-items-center">
        {{ formatAddress(address) }}
      </div>
      <div class="col-sm d-flex justify-content-end">
        <div
          *ngIf="address.isMain"
          class="font-size-primary col-sm d-flex mr-2 align-items-center justify-content-end"
        >
          {{ 'public.profile.address.default' | translate }}
        </div>
        <app-button startIcon="fa-pencil" (click)="onEditAddress(address.id)">{{
          'public.profile.address.edit' | translate
        }}</app-button>
      </div>
    </div>
    <div class="separator my-3"></div>
  </div>
</div>
